module.exports = __webpack_public_path__ + "static/media/bebedouro_lider_passilo_80s.21d7e75d.webp";